import React from 'react'
import defaultClasses from './heroItem.module.scss'
import { bool, string } from 'prop-types'
import { getFastlyUrl } from '@corratech/pylot-image'
import Link from 'next/link'

const HeroItem = (props) => {
    const {
        topHeading,
        heading,
        image,
        textColor,
        imageQuality,
        isLink,
        link,
        contentPosition
    } = props

    const textStyles = {
        color: textColor
    }

    const positionClass =
        contentPosition === 'top'
            ? defaultClasses['hero-item-top-section-top']
            : contentPosition === 'bottom'
            ? defaultClasses['hero-item-top-section-bottom']
            : defaultClasses['hero-item-top-section-middle']

    return (
        <div className={defaultClasses['hero-item']}>
            {isLink && link ? (
                <Link type="link" href={link}>
                    <div>
                        <div
                            className={`${defaultClasses['hero-item-top-section']} ${positionClass}`}
                        >
                            <span
                                style={textStyles}
                                className={
                                    defaultClasses['hero-item-top-heading']
                                }
                            >
                                {topHeading}
                            </span>
                            <h4
                                style={textStyles}
                                className={defaultClasses['hero-item-heading']}
                            >
                                {heading}
                            </h4>
                        </div>
                        {image && (
                            <img
                                src={getFastlyUrl({
                                    src: image,
                                    quality: imageQuality
                                })}
                                alt={heading}
                            />
                        )}
                    </div>
                </Link>
            ) : (
                <>
                    <div
                        className={`${defaultClasses['hero-item-top-section']} ${positionClass}`}
                    >
                        <span
                            style={textStyles}
                            className={defaultClasses['hero-item-top-heading']}
                        >
                            {topHeading}
                        </span>
                        <h4
                            style={textStyles}
                            className={defaultClasses['hero-item-heading']}
                        >
                            {heading}
                        </h4>
                    </div>
                    {image && (
                        <img
                            src={getFastlyUrl({
                                src: image,
                                quality: imageQuality
                            })}
                            alt={heading}
                        />
                    )}
                </>
            )}
        </div>
    )
}

HeroItem.propTypes = {
    topHeading: string,
    heading: string,
    image: string,
    textColor: string,
    isLink: bool,
    link: string,
    contentPosition: string
}

export default HeroItem
